import React from 'react';


export const CrossIcon = () => {
    
    return <svg style={{
        width: '0.88rem',
        height: '0.88rem',
    }} xmlns="http://www.w3.org/2000/svg" width="8.828" height="8.828" viewBox="0 0 8.828 8.828">
        <g transform="translate(-1178.086 -282.086)">
            <line x2="6" y2="6" transform="translate(1179.5 283.5)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
            <line x1="6" y2="6" transform="translate(1179.5 283.5)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
        </g>
    </svg>
};